//import axios from "axios";
import { QueryFunctionContext } from '@tanstack/react-query';
import { MeasurementTableBlockConfig } from "./type";

export const getMeasurementTableBlockConfig = async (context: QueryFunctionContext): Promise<MeasurementTableBlockConfig[]> => {
  //const res = await axios.get("https://jsonplaceholder.typicode.com/posts");
  //return res.data;
  performance.mark('cnf_data_begin');
  let tblblkcfgs = new Array<MeasurementTableBlockConfig>();
  [...Array(context.meta?.numBlocks).keys()].forEach(elem => {
    const tblblkcfg: MeasurementTableBlockConfig = {
      langId: '',
      blockName: 'block_' + elem,
      paramCodes: [...Array(context.meta?.numParams).keys()].map(subelem => 'param_'+elem+'_'+subelem),
    };
    tblblkcfgs.push(tblblkcfg);
  });
  performance.mark('cnf_data_end');
  performance.measure(
    'cnf_data',
    'cnf_data_begin',
    'cnf_data_end',
  );
  const perfConf = performance.getEntriesByName('cnf_data');
  console.log('config generation times (ms)' + perfConf[0].duration);

  return Promise.resolve(tblblkcfgs);
};

